import React from 'react';

function Container({ children, style = {}, ...props }) {
  return (
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        paddingLeft: '0.45rem',
        paddingRight: '0.45rem',
        paddingTop: 0,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

export default Container;
